// D1 Reference type (no Firebase dependency)
type DocumentReference = { path: string; id: string; parent?: any };

export const valueFormatter = (value: DocumentReference, operator: string) => {
  if (value && value.path) return value.path;
  return "";
};
